import "./husky-card.scss"

const HuskyCard = ({ headline, label, value }: HuskyCardProps) => {
    return (
        <div className="xsd__husky-spec msds-bg-gray-1">
            <div className="msds-text-body-0-bold msds-text-gray-10">{headline}</div>
            <div className="msds-text-body-1"><span>{label}*:</span> {value}</div>
        </div>
    )
}

type HuskyCardProps = {
    headline: string,
    label: string,
    value: string | number,
};


export default HuskyCard